import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/royalur/src/app/game/[lobbyID]/LobbyPageContent.tsx");
